import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import emailjs from "@emailjs/browser";

const MySwal = withReactContent(Swal2);

const EditLeadSupportLawyer = (props) => {
  const [loading, setLoading] = useState(false);
  const [recommendation, setRecommendation] = useState("pozytywna");
  const [recommendation_note, setRecommendation_note] = useState("");
  const [users, setUsers] = useState([]);
  var [recArr, setrecArr] = useState([]);

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        try {
          setrecArr(
            JSON.parse(props.leadData.recArr)
              ? JSON.parse(props.leadData.recArr)
              : []
          );
        } catch (err) {
          setrecArr([]);
        }
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchUsers();
  };

  useEffect(() => {
    getData();
  }, []);

  const editLead = async (e) => {
    var arr = recArr;
    var date =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate());
    arr.push({
      support: props.leadData.support,
      topic: props.leadData.support_topic,
      date: date,
      recommendation: recommendation,
      recommendation_note: recommendation_note.replaceAll("\n", ""),
    });
    if (validatePayment()) {
      setLoading(true);

      let keys;
      arr.map((obj) => {
        keys = Object.keys(obj);

        keys.map((val) => {
          obj[val] ? (obj[val] = obj[val].toString().replaceAll('"', "")) : "";
        });
      });

      var body = {
        leadId: props.leadData.id,
        status: props.leadData.status,
        leadName: props.leadData.name,
        field: "recommendation",
        note: recommendation_note,
        value: recommendation === "x" ? "" : recommendation,
        recArr: JSON.stringify(arr),
      };

      await fetch("https://apidevkppp.ftpeople.pl/updateLead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
          var templateParams = {
            to: users.filter((el) => el.name === props.leadData.owner)[0].mail,
            reply_to: props.uData.mail,
            content: `Dzień dobry, udzielono wsparcia. ID kontaktu w systemie: ${
              props.leadData.id
            } - ${
              users.filter((el) => el.name === props.leadData.owner)[0].name
            }`,
            subject:
              "Udzielono wsparcia - " +
              users.filter((el) => el.name === props.leadData.owner)[0].name,
            user_name: props.uData.name,
            user_phone: props.uData.phone,
          };

          emailjs.send("KPPP", "template_h43760d", templateParams).then(
            function (response) {},
            function (error) {}
          );
        })
        .catch((error) => {});

      props.logClientAction(
        "Udzielono wsparcia: " + props.user,
        props.leadData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "lead",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (recommendation.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Rekomendacja - {props.leadData.support_topic}{" "}
                <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                type="text"
                id="name"
                name="name"
                value={recommendation}
                onChange={(e) => {
                  setRecommendation(e.target.value);
                }}
              >
                <option key={0} value={"pozytywna"}>
                  {"pozytywna"}
                </option>
                <option key={0} value={"negatywna"}>
                  {"negatywna"}
                </option>
              </select>
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Notatka do rekomendacji <span className="requiredStar">*</span>
              </label>
              <textarea
                style={{
                  height: "10vh",
                  width: "100%",
                  border: "none",
                  border: "1px solid black",
                  boxShadow: "none",
                }}
                className="textAreaNote"
                value={recommendation_note}
                onChange={(e) => {
                  setRecommendation_note(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editLead}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditLeadSupportLawyer;
